import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ContactSection } from "@/components/ContactSection";

export function PublicShell({ children, showContact = true }) {
  return (
    <div>
      <Navbar />
      {children}
      {showContact && <ContactSection />}
      <Footer />
    </div>
  );
}
